export enum EventName {
	NotificationsViewList = 'Notifications View List',
	NotificationAction = 'Notification Action',
	NotificationsMarkAllRead = 'Notifications Mark All Read',
}
